import {useState} from 'react'
import {BasicBreadcrumbs} from 'src/app/shared/BasicBreadcrumbs'
import {KTCard} from '../../../../_metronic/helpers'
import {PartnerContext} from './PartnerContexts'
import {TipoDocumentListHeader} from './components/TipoDocumentListHeader'
import {TipoDocumentTable} from './components/TipoDocumentTable'

import {Col, Row} from 'react-bootstrap'
import {TipoDocumentFomulario} from './components/TipoDocumentFormulario'
import {TipoDocument} from './tipodocumentInterface'

const Breadcrumbs = [
  {
    title: 'Configuración',
    path: '/configuracion/tipodocument',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DataTipoDocument: TipoDocument = {
  _id: '',
  nombre: '',
  descripcion: '',
  id_empresa: '',
  estado: true,
}
const TipoDocumentPage = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [tipoDocumentData, setTipoDocumentData] = useState<TipoDocument>(DataTipoDocument)
  const [edit, setEdit] = useState(false)
  const [reloadTable, setReloadTable] = useState(false)

  return (
    <>
      <PartnerContext.Provider
        value={{
          searchTerm,
          setSearchTerm,
          tipoDocumentData,
          setTipoDocumentData,
          edit,
          setEdit,
          reloadTable,
          setReloadTable,
        }}
      >
        <BasicBreadcrumbs breadcrumbs={Breadcrumbs} fallbackTitle='Tipo Documento' />

        <Row className='mb-3'>
          <Col xs={6} sm>
            <KTCard>
              <TipoDocumentFomulario />
            </KTCard>
          </Col>
          <Col xs={6} sm>
            <KTCard>
              <TipoDocumentListHeader />
              <TipoDocumentTable />
            </KTCard>
          </Col>
        </Row>
      </PartnerContext.Provider>
    </>
  )
}

export {TipoDocumentPage}
